import React from 'react';
//import { Nav } from 'react-bootstrap';
import {
    Link
} from 'react-router-dom';


export default function DynamicMenu(props) {
    const { items = [], navClassName = '', navItemClassName = '', navItemActiveClassName = '' } = props;
    return (
        <>
            <nav className=" ">
                <div >
                    <ul className={navClassName}>
                        {items.map((item) => {
                            return <>
                                {item.isActive === true ?
                                    <li className='nav-item' key={item.id}>
                                        <Link key={item.id} className={`tableouter ${navItemActiveClassName}`} to={item.href}>
                                          <div className='tableinner'>  <i key={item.id} className="ic fa fa-dashboard"></i> </div>
                                          <div className='tableinner'>  {item.name}</div>
                                            </Link>
                                    </li>
                                    :
                                    (
                                        <>
                                            {item.isdisabled === false ?
                                                (
                                                    <li className='nav-item' key={item.id}>
                                                        <Link key={item.id} className={`tableouter ${navItemClassName}`} to={item.href}>
                                                        <div className='tableinner'>      <i key={item.id} className={item.menuIcon}></i> </div>
                                                        <div className='tableinner'>    {item.name} </div>
                                                            </Link>
                                                    </li>
                                                )
                                                :
                                                (
                                                    <li className='nav-item isDisabled' key={item.id}>
                                                        <Link key={item.id} className={`tableouter ${navItemClassName}`} to={item.href}>
                                                        <div className='tableinner'>     <i key={item.id} className={item.menuIcon}></i> </div>
                                                        <div className='tableinner'>     {item.name} </div>
                                                            </Link>
                                                    </li>
                                                )
                                            }
                                        </>
                                    )

                                }

                            </>
                        })
                        }
                    </ul>
                </div>
            </nav>
        </>
    )
}
